import logo from './logo.svg';
import './App.css';
import ReceiptPrint from './printReceipt';

function App() {
  return (
     <div>
      <ReceiptPrint />
    </div>
  );
}

export default App;
